import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './custom.scss';

const ZMatrix = ({zobject, updates}) => { 
    return (
        <div className="z-matrix">
        {zobject.matrix.map(
            row =>
                <div className="z-row">
                  {row.map(
                      col =>
                          <div className="z-value">{col}</div>)}
                </div>)}
          
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      updates: props.zobject.updates
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZMatrix);
